<template>
  <div
    class="content has-text-left"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <div class="columns">
      <div class="column is-half">
        <table class="table is-striped">
          <tbody>
            <tr>
              <td>{{$t('balance').tTitle()}}</td>
              <td>{{currencies.USD.symbol}}{{User.IB.balance}}</td>
            </tr>
            <tr>
              <td>{{$t('total_earned').tTitle()}}</td>
              <td>{{currencies.USD.symbol}}{{User.IB.total_earned}}</td>
            </tr>
            <tr>
              <td>{{$t('total_paid').tTitle()}}</td>
              <td>{{currencies.USD.symbol}}{{User.IB.total_paid}}</td>
            </tr>
            <tr>
              <td>{{$t('total_clients').tTitle()}}</td>
              <td>{{User.IB.total_clients}}</td>
            </tr>
            <tr>
              <td>{{$t('total_sub_ibs').tTitle()}}</td>
              <td>{{User.IB.total_sub_ib}}</td>
            </tr>
            <tr v-if="User.IB.total_deposits">
              <td>{{$t('total_deposits').tTitle()}}</td>
              <td>
                <span
                  v-for="(value, currency) in User.IB.total_deposits"
                  :key="currency"
                >{{currencies[currency].symbol}}{{value}}</span>
              </td>
            </tr>
            <tr v-if="User.IB.total_withdrawals">
              <td>{{$t('total_withdrawals').tTitle()}}</td>
              <td>
                <span
                  v-for="(value, currency) in User.IB.total_withdrawals"
                  :key="currency"
                >{{currencies[currency].symbol}}{{value}}</span>
              </td>
            </tr>
            <tr v-if="User.IB.total_withdrawals">
              <td colspan="2">
                <span class="title is-size-5">{{$t('tracking_links').tTitle()}}</span>
              </td>
            </tr>
            <tr
              v-for="(value,key) in User.IB.tracking_links"
              :key="key"
            >
              <td>{{key}}</td>
              <td>{{trackURL+value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../app'
import config from '../../config'

export default {
  data() {
    return {
      trackURL: config.URL.track,
      currencies: config.currencies,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    // get IB overview info
    if (!Object.keys(this.User.IB).length) {
      this['logoLoader/set'](true)
      service
        .get('/ib/' + this.User.info.ID)
        .then(response => {
          this['user/setIB'](response.data)
          this['logoLoader/set'](false)
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    }
  },
  methods: {
    ...mapActions(['logoLoader/set', 'user/setIB']),
  },
}
</script>

<style lang="scss" scoped>
// @import "../assets/css/variables";

// .overview li{
table tr td {
  span:not(:last-of-type):after {
    content: ',';
  }
}
</style>



// WEBPACK FOOTER //
// Overview.vue?43faf786